const tiersList = [
  { label: "Pilot", value: "pilot" },
  { label: "Advanced", value: "advanced" },
  { label: "Premium", value: "premium" },
  { label: "Demo", value: "demo" },
];

export default tiersList;
